import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const ROCFilingsAndStatutoryRegisters = () => {
  const serviceData = {
    title: "ROC Filings & Statutory Registers Management",
    heading: "ROC Filings & Statutory Registers Management",
    image: subTopicImages["ROC Filings & Statutory Registers"],
    intro:
      "Ensuring Complete & Timely Compliance with Registrar of Companies (ROC)",
    description: [
      "Every company registered in India is required to maintain statutory registers and file prescribed forms and returns with the Registrar of Companies (ROC) within specified timelines. Any delay, omission or inaccuracy may result in penalties, compounding actions and regulatory scrutiny.",
      "We provide end-to-end ROC compliance management, ensuring that your company remains fully compliant throughout the year.",
    ],
    services: [
      {
        title: "ROC Compliance Services",
        text: "Our services include:",
        list: [
          "annual ROC filing & statutory submissions",
          "filing of event-based ROC forms",
          "preparation of registers & statutory records",
          "updating director & shareholder details",
          "monitoring compliance timelines",
          "maintaining audit-ready documentation",
          "XBRL reporting",
          "CSR compliance documentation",
          "filing of charge creation / modification / satisfaction",
          "rectification of past non-compliances",
        ],
        extraInfo: "",
      },
    ],
    benefitsIntro: "Compliance Control & Monitoring",
    benefits: [
      "We maintain internal compliance calendars and reminders, ensuring that statutory timelines are never missed.",
    ],
    research: "",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      projects={serviceData.benefits}
    />
  );
};

export default ROCFilingsAndStatutoryRegisters;
